var _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5729 9C17.5729 13.6925 13.7529 17.5 9.03644 17.5C4.31999 17.5 0.5 13.6925 0.5 9C0.5 4.30748 4.31999 0.5 9.03644 0.5C13.7529 0.5 17.5729 4.30748 17.5729 9Z",
    fill: "white",
    stroke: "#0054E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20052 9.56179H11.5091L8.75297 12.3068C8.53271 12.5262 8.53271 12.8862 8.75297 13.1055C8.97323 13.3249 9.32904 13.3249 9.5493 13.1055L13.2712 9.39866C13.4915 9.17929 13.4915 8.82491 13.2712 8.60554L9.55495 4.89304C9.44943 4.78771 9.30618 4.72852 9.15678 4.72852C9.00739 4.72852 8.86413 4.78771 8.75862 4.89304C8.53835 5.11241 8.53835 5.46679 8.75862 5.68616L11.5091 8.43679H5.20052C4.88989 8.43679 4.63574 8.68991 4.63574 8.99929C4.63574 9.30866 4.88989 9.56179 5.20052 9.56179Z",
    fill: "#0054E3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2281_9308",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 10,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20052 9.56179H11.5091L8.75297 12.3068C8.53271 12.5262 8.53271 12.8862 8.75297 13.1055C8.97323 13.3249 9.32904 13.3249 9.5493 13.1055L13.2712 9.39866C13.4915 9.17929 13.4915 8.82491 13.2712 8.60554L9.55495 4.89304C9.44943 4.78771 9.30618 4.72852 9.15678 4.72852C9.00739 4.72852 8.86413 4.78771 8.75862 4.89304C8.53835 5.11241 8.53835 5.46679 8.75862 5.68616L11.5091 8.43679H5.20052C4.88989 8.43679 4.63574 8.68991 4.63574 8.99929C4.63574 9.30866 4.88989 9.56179 5.20052 9.56179Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2281_9308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.25879,
    y: 2.25,
    width: 13.5547,
    height: 13.5,
    fill: "#0054E3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueArrow);
export default __webpack_public_path__ + "static/media/blueArrow.32bfa766d18ceaf1ed4653861d912a25.svg";
export { ForwardRef as ReactComponent };